/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconSeparator = createReactComponent("outline", "separator", "IconSeparator", [["path", { "d": "M3 12l0 .01", "key": "svg-0" }], ["path", { "d": "M7 12l10 0", "key": "svg-1" }], ["path", { "d": "M21 12l0 .01", "key": "svg-2" }]]);

export { IconSeparator as default };
//# sourceMappingURL=IconSeparator.mjs.map
